import { useContext, useRef, useState } from "react";
import { useFormik } from "formik";
import { getDeviceInfo, getGroupAuthId } from "../../Components/Kalyanlite/utils";
import { LoginContext } from "../../Contexts/LoginContext";
import EndPoints from "../../Constants/EndPoints";
import { GET, POST } from "../../Services/api_services";
import config from "../../config";
import Constants from "../../Constants/constants";
import { SelectFamilyInput } from "./PartnerPreferenceUtils";
import LoaderGif from "../../Gif/loader.gif"
import { useDispatch, useSelector } from "react-redux";
import { registerStarList } from "../../Store/Home/Action";

import staricon from "../../Images/star-icon.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import RouteSegments from "../../Routes/RouteSegment";
import TrustmarkIdImage from '../../Images/Group 3785.svg'
 import { validateImage } from "../../Utils";
 import {  NotificationPopup } from "../../Components/CommonPopup";
import * as Images from "../../Components/Kalyanlite/assets/images"
 import { useTranslation } from "react-i18next";
 


export default function IdProof({ data, dropDown }) {
    const { t:trans } = useTranslation();
    const navigate = useNavigate();

    const isCommunitySite = localStorage.getItem(
        Constants.loginLocalStorageKeys.isCommunitySite
    );
    const { loginDetail, logout } = useContext(LoginContext);
    const dispatch = useDispatch();

    const { ProfileData } = useSelector(state => ({
        ProfileData: state.DashBoardAPI?.ProfileData?.data
      }));
    const fileInputRef = useRef(null);
      
    
    const [isIdsProofUploading, setIsIdsProofUploading] = useState(false);
  const [notification, setNotification] = useState({ show: false, title: "", message: "" })

  const showNotification = ({ description = "", title = `${trans('photos.status')}!` }) => {
    setNotification({ show: true, title: title, message: description })
  }
  const closeNotification = () => { 
    setNotification({ show: false, message: "", title: "" })
  }


const onIdProofFileChange = (event) => {
    const file = event.target.files[0];
    validateImage({
          file,
          onSizeError: (img) => {
            showNotification({ title: "Invalid image", description: trans('upload_photos.height_and_width_must_be_more') })
          },
          onExtensionError: (fileType) => {
            showNotification({ title: "Invalid image", description: "Invalid extension!" })
          },
          onFileSizeError: (img) => {
            showNotification({ title: "Invalid image", description: trans('upload_photos.image_size_should_not_be_great') })
          },
          onSuccess: (img, readerStr) => {
            handleUpload(file, "idproof")
          }
        })
};

    // Add this function to handle file selection and upload
const handleUpload = async (file, type = "idproof") => {
    if (file.size / 1024 / 1024 < 10) {
        let fileData = new FormData();

        fileData.append("userId", loginDetail()[1]);
        fileData.append("trustDocumentUploadFrom", getDeviceInfo());
        fileData.append("documents", file);
        fileData.append("type", type);
        fileData.append("trustrequesttypeid", 88);
        if(getGroupAuthId()){
        fileData.append("recieverprofileid", getGroupAuthId());
        }
        fileData.append("requestfulfilledfrom", getDeviceInfo());
        fileData.append("requestfulfilledvia", "afterRegistration");
        fileData.append("editFrom", "afterRegistration");
        fileData.append("loginFrom", getDeviceInfo());

        setIsIdsProofUploading(true);

        try {
             let response = await axios.post(
            `${config.api.API_URL}${EndPoints.trustDocumentUploadUrl()}`,
            fileData,
            {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            }
         );

            if (response.status === 200 && response.data.data.status === "SUCCESS") {
                setIsIdsProofUploading(false);
                if (fileInputRef.current) fileInputRef.current.value = "";
                handleSkipClick();
            } else {
                alert("Upload failed. Please try again.");
                setIsIdsProofUploading(false);
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        } catch (err) {
            alert("Upload failed. Please try again.");
            setIsIdsProofUploading(false);
            if (fileInputRef.current) fileInputRef.current.value = "";
        }
    } else {
        alert("Please upload file less than 10 mb");
    }
};
   


   

    const handleSkipClick = () => {
        
        if(localStorage.getItem(Constants.loginLocalStorageKeys.isOriginalImageUploaded) == "true"){
            if (isCommunitySite) {
                if (localStorage.getItem("submitpref")) {
                    localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegments.MATCH_GROUP)
                    navigate(RouteSegments.MATCH_GROUP)
                }
            } else {
                navigate(RouteSegments.PROFILE_PREVIEW,{state : {isFrom : "afterreg"}})
            }
        }else{
            localStorage.setItem(Constants.loginLocalStorageKeys.loginCurrentPage, RouteSegments.UPLOAD_PHOTO_PAGE)
            sessionStorage.setItem("photoPage",true);
            navigate(RouteSegments.UPLOAD_PHOTO_PAGE,{state : { isFrom : "previous" }})
        }
    }

    return (
        <>
  

    {
        notification.show
          ? <NotificationPopup close={closeNotification} title={notification.title} content={notification.message} />
          : null
      }

    <div className="mx-2 lg:pb-[2rem] md:pb-[1rem] pb-[0.5rem]">
        <div className="mt-[2rem] md:mt-[2rem] lg:mt-[2rem] lg:pl-[2rem]">
            <div className="space-y-2">
                <p
                    ref={(ref) => {
                        ref?.scrollIntoView({ behavior: "smooth" })
                    }}
                    className="text-[#D63838] font-bold text-[18px] md:text-[18px] lg:text-[22px]">
                    Add ID Proofs
                </p>
                         <p className="text-[#2C2B2B] text-[14px] md:text-[16px] lg:text-[18px] mt-2">
                             Add ID Proofs to Complete your Profile and double your chances of finding your Perfect Match.
                         </p>
            </div>
        </div>
      <div className={`mt-7 md:mx-auto lg:w-[30rem] flex justify-center items-center gap-2 md:gap-5 py-2 px-2 md:px-5 rounded-lg bg-[#EEEEEE]`}>
            <div className="w-[8rem] h-[7rem] flex items-center justify-center"><img className="md:h-[3rem]" src={Images.IdproofIconAfterRegPage} alt="" />
            </div>
            <div className="text-[13px] space-y-2" >
                    <p className="font-semibold text-[#2C2B2B] text-[16px] mb-1">Why Add ID Proofs?</p>
                    <p className="text-[#555] text-[14px] mb-1">
                    It helps build trust and genuineness among profiles.
                    </p>
                    <p className="text-[#555] text-[13px]">
                    <span className="font-bold">Note:</span> Id Proofs are not visible to anyone for security reasons. However Kalyan Matrimony will indicate presence of such documents as a mark of genuinity.
                    </p>
            </div>
      </div>
            <div className="p-0 md:p-0 lg:px-[2rem]">
               
                <div className="flex  mt-7 items-center justify-around  py-4">
                    <div></div>
                    <button
                           type="button"
                    className="text-[14px] bg-[#DA3535] cursor-pointer text-white px-4 lg:px-[2.5rem] py-2.5 rounded-md hover:bg-[#B72A2A]"
                    onClick={() => fileInputRef.current.click()}
                    disabled={isIdsProofUploading}>
                    {isIdsProofUploading ? "Uploading..." : "Add ID Proofs"}
                    </button>
                     <input
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    type="file"
                    accept="image/jpeg, image/png, application/pdf"
                    onChange={onIdProofFileChange}
                />
                    {isCommunitySite ? null : (

                        <div className="pl-[6rem] md:pl-[12rem]">
                            {false ? '' :
                                <button
                                    type="button"
                                    onClick={handleSkipClick}
                                    className="cursor-pointer pt-2 text-[#C1C1C1] text-[13px] underline"
                                >
                                    Skip
                                </button>}
                        </div>
                    )}
                </div>

            </div>              
    </div >


  </>

);
}
